<section *ngIf="!hasOrderHistory" class="never-ordered">
  <p>You don’t have any current orders yet.</p>
  <p>Schedule your first Home pick up & delivery now!</p>
</section>

<section *ngIf="hasOrderHistory" class="list-current-empty">
  <p>You don’t have any current orders at the moment.</p>
</section>

<a (click)="redirectToBooking()"  class="btn primary left-rounded with-arrow with-icon" [id]="newBooking">Schedule a booking</a>